export const environment = process.env.VUE_APP_ENV;
export const apiUrl = process.env.VUE_APP_PASSEPARTOUT_API_URL;
export const appUrl = process.env.VUE_APP_PASSEPARTOUT_APP_URL;
export const keycloakUrl = process.env.VUE_APP_KEYCLOAK_URL;
export const keycloakRealm = process.env.VUE_APP_KEYCLOAK_REALM;
